<template>
    <div class="flexContainer full">
        <section id="sectionPrincipal" class="flexContainer fd-c full t-fd-r t-fw-nw">
            <section class="planosWrapper flexContainer jc-sb mobileNot">
                <section class="searchResultsWrapper size3of4 flexContainer fd-c tabletNot">
                    <section>
                        <div class="flexContainer ai-c jc-sb">
                            <div class="flexContainer ai-c jc-sb">
                                <router-link
                                    v-if="hasAccessCreate('campaign_manager')"
                                    to="/campaigns/create"
                                    tag="span"
                                    class="btnExp iBlock pointer mobileNot txtCenter active fright"
                                    exact
                                >
                                    {{ $t("headerAdmin.campaign") }}
                                </router-link>
                            </div>
                        </div>
                        <hr class="full mt10 separator" />
                        <transition-group name="fade" class="resultsWrapper flexContainer fw-w ">
                            <div
                                v-for="campaign in campaigns"
                                :key="campaign.name"
                                v-if="campaign.active !== false"
                                class="listDisplay rel full flexContainer fd-c ai-c jc-fs"
                            >
                                <div class="listDisplay rel full flexContainer fd-c ai-c jc-fs list">
                                    <div class="listDisplay full ai-c jc-sb flexContainer">
                                        <div class="flexContainer fd-c size1of5">
                                            <span class="listTitle center txtCenter">{{ campaign.name }}</span>
                                        </div>
                                        <div class="flexContainer fd-c size1of5">
                                            <span v-if="campaign.createdBy.hasOwnProperty('firstname')">
                                                {{ $t("campaignList.createdBy") }}
                                                {{ campaign.createdBy.firstname }} {{ campaign.createdBy.lastname }}
                                                {{ $t("campaignList.createdOn") }} {{ campaign.createdAt }}
                                            </span>
                                            <span v-if="campaign.modifiedBy.hasOwnProperty('firstname')">
                                                {{ $t("campaignList.modifiedBy") }}
                                                {{ campaign.modifiedBy.firstname }} {{ campaign.createdBy.lastname }}
                                                {{ $t("campaignList.modifiedOn") }} {{ campaign.modifiedDate }}
                                            </span>
                                        </div>
                                        <div class="flexContainer fd-c size1of5">
                                            <span v-if="campaign.launchDate !== null" class="center">{{ campaign.launchDate }}</span>
                                            <span v-else class="center">NO LAUNCH DATE</span>
                                        </div>
                                        <div class="flexContainer fd-c size1of5">
                                            <span v-if="campaign.endDate !== null" class="center">{{ campaign.endDate }}</span>
                                            <span v-else class="center">NO END DATE</span>
                                        </div>
                                        <div class="flexContainer fd-c size1of5">
                                            <button class="btn editBtn abs center" @click="editCampaign(campaign)">
                                                {{ $t("editCampaign.edit") }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </transition-group>
                    </section>
                </section>
            </section>
            <EditCampaign v-if="showEditCampaign" @hideEditCampaign="modalClose($event)"></EditCampaign>
        </section>
    </div>
</template>

<script>
import EditCampaign from "../campaign/EditCampaign.vue";
import { mapActions, mapState } from "vuex";

export default {
    components: {
        EditCampaign
    },
    data: () => ({
        showEditCampaign: false
    }),
    watch: {
        $route(to, from) {
            this.to = to;
            this.from = from;
            if (this._.size(to.query) === 0) {
                this.clearFilters();
            }
            if (this.$route.query.offset === undefined) {
                this.$route.query.offset = 1;
            }
            this.updateQuery(to);
        }
    },
    methods: {
        ...mapActions("campaign/list", ["populateCampaignsList"]),
        ...mapActions({
            setEditCampaignObj: "items/setEditCampaignObj",
            setCampaignList: "items/setCampaignList"
        }),
        editCampaign(campaign) {
            this.showEditCampaign = true;
            this.setEditCampaignObj(campaign);
            this.setCampaignList(this.campaign);
        },
        modalClose(close) {
            this.showEditCampaign = close;
        }
    },
    computed: {
        ...mapState("campaign/list", ["campaigns"])
    },
    created() {
        this.populateCampaignsList("stand");
    }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// CampaignList.vue?7cfb207c